import { service } from '../utils/request';

export function getConfigs() {
    return service({
        url: window.location.origin + '/init.json',
        method: 'get'
    });
}

export function getProductById(id) {
    return service({
        url: '/product/' + id,
        method: 'get'
    });
}

export function newLead(data) {
    return service({
        url: '/NewLead',
        method: 'post',
        data
    });
}

export function leadByBirthday(data){
    return service({
        url: '/UpdateLeadDetailsByBirthdate',
        method: 'post',
        data
    });
}

export function findOrgByNumber(id){
    return service({
        url: 'https://data.brreg.no/enhetsregisteret/api/enheter/' + id,
        method: 'get'
    });
}

export function accountingPointsAlternatives(data){
    return service({
        url: '/QueryAPByAlternatives',
        method: 'post',
        data
    });
}

export function orderPlace(data){
    return service({
        url: '/OrderPlaced',
        method: 'post',
        data
    });
}